import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message-container" }
const _hoisted_2 = { class: "account-list" }
const _hoisted_3 = { class: "receiver-list" }
const _hoisted_4 = { class: "specify-account" }
const _hoisted_5 = { class: "select-buttons" }
const _hoisted_6 = { class: "receiver-list" }
const _hoisted_7 = { class: "specify-account" }
const _hoisted_8 = { class: "select-buttons" }
const _hoisted_9 = { class: "message-content" }
const _hoisted_10 = { class: "format-toolbar" }
const _hoisted_11 = { class: "send-mode" }

import { ref, reactive, computed, watch, onBeforeUnmount, shallowRef, h } from 'vue'
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";

interface Account {
  strTelegramNo: string; // TelegramNo
  strAccount: string; // Account
  strNickName: string; // NickName
}

interface SenderAccount {
  strAccount: string;
  strStatus: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SendMessageModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

const senders = ref<Account[]>([]);
const receivers = ref<Account[]>([]);
const receiverIds = ref<Account[]>([]);
const formState = reactive({
  sender: "",
  selectedTargets: [] as string[],
  message: "",
  messageType: 1,
});

const formStateID = reactive({
  sender: "",
  selectedTargets: [] as string[],
  message: "",
  messageType: 1,
});

// 监听模态框显示状态，当显示时获取账号列表
watch(
  () => props.visible,
  async (newVisible) => {
    if (newVisible) {
      await fetchAccountList();
      formState.selectedTargets = []; // 重置选择状态
      formStateID.selectedTargets = []; // 重置选择状态
    }
  }
);

// 获取账号列表
const fetchAccountList = async () => {
  console.log("fetchAccountList");
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();

    const sendersResponse = await client.getAccountList(username);
    if (sendersResponse && Array.isArray(sendersResponse.list)) {
      senders.value = sendersResponse.list
        .filter((sender: SenderAccount) => sender.strStatus === "3")
        .map((sender: SenderAccount) => ({
          strTelegramNo: sender.strAccount,
          strAccount: sender.strAccount,
          strNickName: sender.strAccount,
        }));
    }

    await refreshReceiverList();
  } catch (error) {
    console.error("获取账号列表错误:", error);
    message.error("获取账号列表失败");
  }
};

// 添加刷新发送者列表的方法
// 同样更新刷新方法
const refreshSendersList = async () => {
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();
    const response = await client.getAccountList(username);

    if (response && Array.isArray(response.list)) {
      senders.value = response.list
        .filter((sender: SenderAccount) => sender.strStatus === "3")
        .map((sender: SenderAccount) => ({
          strTelegramNo: sender.strAccount,
          strAccount: sender.strAccount,
          strNickName: sender.strAccount,
        }));

      console.log("刷新后的发送者列表:", senders.value);
      if (senders.value.length === 0) {
        message.warning("没有可用的发送者账号");
      }
    }
  } catch (error) {
    console.error("刷新发送者列表错误:", error);
    message.error("刷新发送者列表失败");
  }
};

// 修改发送者选择框的点击事件
const handleSenderFocus = async () => {
  if (senders.value.length === 0) {
    await refreshSendersList();
  }
};

// 加发送者选择处理函数
const handleSenderChange = (value: string) => {
  formState.sender = value;
};

 
const handleOpenForbid = async() => {
  console.log("handleOpenForbid");
  const client = TelegramClient.getInstance();
  const account = localStorage.getItem("username") || "";

  if (!formState.sender) {
    message.warning("请选择发送者");
    return;
  }
  const result = await client.sendOpenForbid(
      account,
      formState.sender,
      ""
    );
    if (result && result.code === 1) {
      const succesMsg = result?.reason || "解除成功";
      message.success(succesMsg);
      //emit("update:visible", false);
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
    
};

const handleCancel = () => {
  console.log("handleCancel");
  resetForm();
  emit("update:visible", false);
};


//handleIDSend
const handleIDSend = async () => {
  console.log("handleIDSend");
  if (!formState.sender) {
    message.warning("请选择发送者");
    return;
  }

  if (!formStateID.selectedTargets.length) {
    message.warning("请选择至少一个接收者");
    return;
  }

  if (!formState.message.trim()) {
    message.warning("请输入消息内容");
    return;
  }

  try {
    const messageText = formState.message;
    const client = TelegramClient.getInstance();
    const account = localStorage.getItem("username") || "";
    // 修改这部分逻辑，直接使用账号创建目标对象
    const targets = formStateID.selectedTargets.map((targetId) => {
      // 尝试从receivers中查找账号信息，如果找不到就直接使用输入的账号
      const receiver = receivers.value.find(
        (acc) => acc.strTelegramNo === targetId
      );
      return { 
        Id: receiver ? Number(receiver.strTelegramNo) : Number(targetId) 
      };
    });
    //Id
    const result = await client.sendMessage(
      account,
      formState.sender,
      targets,
      messageText,
      formState.messageType
    );

    console.log("handleSend");

    if (result && result.code === 1) {
      message.success("发送成功");
      emit("success");
      resetForm();
      //emit("update:visible", false);
    } else {
      const errorMsg = result?.message || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
  } catch (error) {
    console.error("发送消息错误:", error);
    message.error(
      `发送失败: ${error instanceof Error ? error.message : String(error)}`
    );
  }
};



const handleSend = async () => {
  console.log("handleSend");
  if (!formState.sender) {
    message.warning("请选择发送者");
    return;
  }

  if (!formState.selectedTargets.length) {
    message.warning("请选择至少一个接收者");
    return;
  }

  if (!formState.message.trim()) {
    message.warning("请输入消息内容");
    return;
  }

  try {
    const messageText = formState.message;
    const client = TelegramClient.getInstance();
    const account = localStorage.getItem("username") || "";
    // 修改这部分逻辑，直接使用账号创建目标对象
    const targets = formState.selectedTargets.map((targetId) => {
      // 尝试从receivers中查找账号信息，如果找不到就直接使用输入的账号
      const receiver = receivers.value.find(
        (acc) => acc.strAccount === targetId
      );
      return { 
        name: receiver ? receiver.strAccount : targetId 
      };
    });

    const result = await client.sendMessage(
      account,
      formState.sender,
      targets,
      messageText,
      formState.messageType
    );

    console.log("handleSend");

    if (result && result.code === 1) {
      message.success("发送成功");
      emit("success");
      resetForm();
      //emit("update:visible", false);
    } else {
      const errorMsg = result?.message || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
  } catch (error) {
    console.error("发送消息错误:", error);
    message.error(
      `发送失败: ${error instanceof Error ? error.message : String(error)}`
    );
  }
};

const resetForm = () => {
  Object.assign(formState, {
    sender: "",
    selectedTargets: [],
    selectedTargetIds:[],
    //message: "",
    messageType: 1,
  });
};

const handleSelectChange = (selectedValues: string[]) => {
  if (Array.isArray(selectedValues)) {
    formState.selectedTargets = selectedValues.filter(value => value !== '');
  } else {
    formState.selectedTargets = [];
  }
  
  if (formState.selectedTargets.length === 0) {
    message.info('请至少选择一个接收者');
  }
  console.log("handleSelectChange")

};


const handleSelectChangeId = (selectedValues: string[]) => {
  if (Array.isArray(selectedValues)) {
    formStateID.selectedTargets = [];
    let list = selectedValues.filter(value => value !== '');
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        console.log("handleSelectChangeId "+element);
        const id = element.trim();
        formStateID.selectedTargets.push(id);
     }
    //formStateID.selectedTargets = selectedValues.filter(value => value !== '');
  } else {
    formStateID.selectedTargets = [];
  }
  
  if (formStateID.selectedTargets.length === 0) {
    message.info('请至少选择一个接收者');
  }
  console.log("handleSelectChangeId")

};



// 添加刷新接收者列表的方法
const refreshReceiverList = async () => {
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();
    const response = await client.getPrivateChatList(username, "session", 1);

    if (response && Array.isArray(response)) {

      let list = response.map((receiver: any) => ({
        strTelegramNo: receiver.strTelegramNo,
        strAccount: receiver.strAccount,
        strNickName: receiver.strNickName || receiver.strAccount,
      }));
      receivers.value = list.filter((value) => value.strAccount != "");
      receiverIds.value = list.filter((value) => value.strTelegramNo != "");
      console.log("刷新后的接收者列表:", receivers.value);
      console.log("刷新后的接收者数字ID列表:", receiverIds.value);
      if (receivers.value.length === 0) {
        message.warning("没有可用的接收者账号");
      }
    }
  } catch (error) {
    console.error("刷新接收者列表错误:", error);
    message.error("刷新接收者列表失败");
  }
};

// 添加过滤函数
const filterOption = (inputValue, option) => {
  console.log("filterOption");
  if (!inputValue || inputValue.length === 0) {
    return true;
  }

  const inputFirstChar = inputValue.charAt(0).toLowerCase();
  const valueFirstChar = option.value.charAt(0).toLowerCase(); // 使用 option.value
  return valueFirstChar === inputFirstChar;

};


// 添加批量选择函数
const handleBatchSelect = (count: number) => {
  const currentSelected = new Set(formState.selectedTargets);
  const availableReceivers = receivers.value
    .filter(receiver => !currentSelected.has(receiver.strAccount))
    .map(receiver => receiver.strAccount);

  // 计算还需要选择多少条
  const needToSelect = count;
  const newSelected = availableReceivers.slice(0, needToSelect);

  // 合并已选择的和新选择的
  formState.selectedTargets = [...currentSelected, ...newSelected];

  // 提示实际选择数量
  const actualSelected = formState.selectedTargets.length;
  message.info(`已选择 ${actualSelected} 条记录`);
};

const handleBatchSelectID = (count: number) => {
  const currentSelected = new Set(formStateID.selectedTargets);
  const availableReceivers = receiverIds.value
    .filter(receiver => !currentSelected.has(receiver.strTelegramNo))
    .map(receiver => receiver.strTelegramNo);

  // 计算还需要选择多少条
  const needToSelect = count;
  const newSelected = availableReceivers.slice(0, needToSelect);

  // 合并已选择的和新选择的
  formStateID.selectedTargets = [...currentSelected, ...newSelected];

  // 提示实际选择数量
  const actualSelected = formStateID.selectedTargets.length;
  message.info(`已选择 ${actualSelected} 条记录`);
};



// 添加取消选择函数
const handleCancelSelect = () => {
  formState.selectedTargets = [];
  message.info('已清除所有选择');
};

const handleCancelSelectID = () => {
  formStateID.selectedTargets = [];
  message.info('已清除所有选择');
};


// 添加链接编辑对话框的状态
const linkModalVisible = ref(false)
const linkForm = reactive({
  text: '',
  url: ''
})

// 修改格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    // 处理多行引用
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    // 保存当前光标位置
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    // 显示链接编辑对话框
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  formState.message = text.substring(0, start) + newText + text.substring(end);
  
  // 恢复焦点并更新光标位置
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
  console.log("dadf");
};

// 添加指定账号相关的响应式变量和方法
const specifiedAccount = ref('');
const specifiedId = ref('');
const handleAddSpecifiedAccount = () => {
  const account = specifiedAccount.value.trim();
  if (!account) {
    message.warning('请输入账号');
    return;
  }

  // 检查账号是否已经在选中列表中
  if (formState.selectedTargets.includes(account)) {
    message.warning('该账号已在列表中');
    return;
  }

  // 添加到选中列表
  formState.selectedTargets.push(account);
};



const handleAddSpecifiedID = () => {
  const id = specifiedId.value.trim();
  if (!id) {
    message.warning('请输入数字ID');
    return;
  }

  // 检查账号是否已经在选中列表中
  if (formStateID.selectedTargets.includes(id)) {
    message.warning('该账号已在列表中');
    return;
  }

  // 添加到选中列表
  formStateID.selectedTargets.push(id);
};



return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_button_group = _resolveComponent("a-button-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: isOpen.value,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((isOpen).value = $event)),
    title: "发送消息",
    onCancel: handleCancel,
    onOk: handleSend,
    okText: "发送",
    cancelText: "关闭",
    width: "1200px",
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: handleCancel
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [
          _createTextVNode("关闭")
        ])),
        _: 1
      }),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        onClick: handleOpenForbid
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("解除双向")
        ])),
        _: 1
      }),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        onClick: handleSend
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode("用户名发送")
        ])),
        _: 1
      }),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        onClick: handleIDSend
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [
          _createTextVNode("ID发送")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[19] || (_cache[19] = _createElementVNode("h3", null, "发送账号", -1)),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: formState.sender,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.sender) = $event)),
                placeholder: "请选择发送者",
                style: {"width":"100%"},
                onChange: handleSenderChange,
                onFocus: handleSenderFocus
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(senders.value, (sender) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: sender.strAccount,
                      value: sender.strAccount
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sender.strNickName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[24] || (_cache[24] = _createElementVNode("h3", null, "接收账号", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: specifiedAccount.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((specifiedAccount).value = $event)),
                  placeholder: "请输入指定账号",
                  style: {"width":"calc(100% - 80px)"},
                  onPressEnter: handleAddSpecifiedAccount
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: handleAddSpecifiedAccount
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("添加")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_button, {
              size: "small",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleBatchSelect(100)))
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode("选择100条")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              size: "small",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleBatchSelect(500))),
              style: {"margin-left":"8px"}
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("选择500条")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              size: "small",
              onClick: handleCancelSelect,
              style: {"margin-left":"8px"},
              type: "danger"
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("取消选择")
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_a_form_item, { style: {"margin-top":"8px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: formState.selectedTargets,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.selectedTargets) = $event)),
                mode: "multiple",
                placeholder: "请选择接收者",
                style: {"width":"100%"},
                onChange: handleSelectChange,
                maxTagCount: 10,
                autoClearSearchValue: true,
                filterOption: filterOption,
                showSearch: true,
                optionFilterProp: "children",
                options: receivers.value.map(receiver => ({
              value: receiver.strAccount,
              label: receiver.strNickName
            }))
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[29] || (_cache[29] = _createElementVNode("h3", null, "接收数字ID", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: specifiedId.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((specifiedId).value = $event)),
                  placeholder: "请输入指定数字ID",
                  style: {"width":"calc(100% - 80px)"},
                  onPressEnter: handleAddSpecifiedID
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: handleAddSpecifiedID
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("添加")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_button, {
              size: "small",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (handleBatchSelectID(100)))
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [
                _createTextVNode("选择100条")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              size: "small",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (handleBatchSelectID(500))),
              style: {"margin-left":"8px"}
            }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("选择500条")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              size: "small",
              onClick: handleCancelSelectID,
              style: {"margin-left":"8px"},
              type: "danger"
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createTextVNode("取消选择")
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_a_form_item, { style: {"margin-top":"8px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: formStateID.selectedTargets,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formStateID.selectedTargets) = $event)),
                mode: "multiple",
                placeholder: "请选择接收者",
                style: {"width":"100%"},
                onChange: handleSelectChangeId,
                maxTagCount: 15,
                autoClearSearchValue: true,
                filterOption: filterOption,
                showSearch: true,
                optionFilterProp: "children",
                options: receiverIds.value.map(receiver => ({
              value: receiver.strTelegramNo,
              label: receiver.strTelegramNo
            }))
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[41] || (_cache[41] = _createElementVNode("h3", null, "消息内容", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_button_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: formatText.bold,
                  title: "粗体"
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("B")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.italic,
                  title: "斜体"
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("I")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.underline,
                  title: "下划线"
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("U")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.strikethrough,
                  title: "删除线"
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("S")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.code,
                  title: "行内代码"
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode("{}")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.codeblock,
                  title: "代码块"
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("{ }")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.link,
                  title: "添加链接"
                }, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                    _createTextVNode("🔗")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.spoiler,
                  title: "隐藏文本"
                }, {
                  default: _withCtx(() => _cache[37] || (_cache[37] = [
                    _createTextVNode("��")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: formatText.quote,
                  title: "引用"
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createTextVNode("\"")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_textarea, {
            value: formState.message,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formState.message) = $event)),
            placeholder: "请输入消息内容",
            rows: 10,
            maxlength: 100000
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_radio_group, {
              value: formState.messageType,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((formState.messageType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: 1 }, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode("普通消息")
                  ])),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: 2 }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("POSTMAN消息")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ]),
      _createVNode(_component_a_modal, {
        visible: linkModalVisible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((linkModalVisible).value = $event)),
        title: "添加链接",
        onOk: handleLinkConfirm,
        okText: "确定",
        cancelText: "取消"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: linkForm,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "链接文字" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: linkForm.text,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((linkForm.text) = $event)),
                    placeholder: "请输入链接显示的文字"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "链接地址" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: linkForm.url,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((linkForm.url) = $event)),
                    placeholder: "请输入链接地址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})